/* Sale Countdown
 * ---------------
 * One rAF-free interval per section, ticking on the second boundary.
 *
 * Deliberate choices:
 *  - Only the digit whose value actually changed gets the flip class, so the
 *    row is not re-animating four cells every second.
 *  - The days cell is hidden until it is non-zero. A permanent "00 DAYS" is
 *    noise, and hiding it is what makes the strip collapse to H:M:S under 24h.
 *  - Expiry swaps to a message instead of parking on 00:00:00, which is the
 *    usual failure mode of these banners.
 *  - The interval is cleared when the section scrolls out of view and restarted
 *    when it returns, so a page left open in a background tab is not ticking
 *    forever.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // "2026-08-20 23:59" is not valid ISO on Safari, so normalise before parsing.
  function parseEnd(raw) {
    if (!raw) return null;
    var s = String(raw).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) s += ':00';
    var t = Date.parse(s);
    return isNaN(t) ? null : t;
  }

  function Countdown(root) {
    this.root = root;
    this.end = parseEnd(root.getAttribute('data-end'));
    this.urgentMs = (parseFloat(root.getAttribute('data-urgent-hours')) || 0) * 3600000;
    this.cells = {};
    this.last = {};

    var self = this;
    ['days', 'hours', 'minutes', 'seconds'].forEach(function (u) {
      self.cells[u] = root.querySelector('[data-unit="' + u + '"]');
    });
    this.dayCell = root.querySelector('.sc__unit--day');



    if (this.end === null) {
      root.classList.add('is-expired');
      return;
    }

    this.timer = null;

    // Paint and start unconditionally. An earlier version gated the first
    // render on IntersectionObserver, and when that observer did not fire the
    // card sat at 00:00:00 forever. Rendering must never depend on an optional
    // optimisation; the observer below only pauses an already-running clock.
    this.tick();
    this.start();
    this.observe();
  }

  Countdown.prototype.observe = function () {
    if (!('IntersectionObserver' in window)) return;
    var self = this;
    // Retained on the instance so it cannot be collected while observing.
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) self.start();
        else self.stop();
      });
    }, { rootMargin: '200px' });
    this.io.observe(this.root);
  };

  Countdown.prototype.start = function () {
    if (this.timer) return;
    if (this.root.classList.contains('is-expired')) return;
    this.tick();
    this.timer = setInterval(this.tick.bind(this), 1000);
  };

  Countdown.prototype.stop = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  Countdown.prototype.set = function (unit, value) {
    var el = this.cells[unit];
    if (!el) return;
    var next = pad(value);
    if (this.last[unit] === next) return;
    this.last[unit] = next;
    el.textContent = next;
    if (REDUCED) return;
    el.classList.remove('is-ticking');
    void el.offsetWidth; // restart the animation
    el.classList.add('is-ticking');
  };

  Countdown.prototype.tick = function () {
    var left = this.end - Date.now();

    if (left <= 0) {
      this.stop();
      this.root.classList.add('is-expired');
      this.root.classList.remove('is-urgent');
      return;
    }

    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;

    if (this.dayCell) this.dayCell.hidden = d === 0;


    this.set('days', d);
    this.set('hours', h);
    this.set('minutes', m);
    this.set('seconds', sec);

    if (this.urgentMs > 0) {
      this.root.classList.toggle('is-urgent', left <= this.urgentMs);
    }
  };

  function init() {
    document.querySelectorAll(".sc[data-end]").forEach(function (el) {
      if (!el.__scInit) {
        el.__scInit = true;
        new Countdown(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-renders sections on setting changes.
  document.addEventListener('shopify:section:load', init);
})();
